import { PageSlugs } from './pageSlugs'

export const STORY_CARD_TYPES = ['alumni', 'students', 'parents']

/** Canonical pages that host each story-card carousel. */
export const STORY_CARD_PAGE_SLUGS = {
  alumni: PageSlugs.alumni,
  students: PageSlugs.studentExperiences,
  parents: PageSlugs.parentTestimonials,
}

export const STORY_CARD_MENU_OPTIONS = STORY_CARD_TYPES.map((type) => ({
  type,
  slug: STORY_CARD_PAGE_SLUGS[type],
  labelKey: `admin.storyCards.${type}Title`,
}))

export function storyCardTypeForPageSlug(slug) {
  return STORY_CARD_TYPES.find((type) => STORY_CARD_PAGE_SLUGS[type] === slug) || null
}

export function storyCardLinkValue(type) {
  return `story:${type}`
}

export function isStoryCardLinkValue(value) {
  return typeof value === 'string' && value.startsWith('story:')
}

export function storyCardTypeFromLinkValue(value) {
  return isStoryCardLinkValue(value) ? value.slice(6) : null
}

export function resolveStoryCardType(page, slug) {
  if (page?.story_card_type) return page.story_card_type
  return storyCardTypeForPageSlug(slug)
}
